module.exports = __webpack_public_path__ + "img/1.580b96fe.jpg";